<template>
<div id="polling-data-rcp">
    <ClaimsTable 
        :claims="claims" 
        :loading="loading" 
        :display-links="false"
        />
</div>
</template>

<script>
import ClaimsTable from './ClaimsTable.vue';

export default {
    name: 'search-results-table',
    components: {
        ClaimsTable,
    },
    props: {
        claims: {
            type: [Array, Object],
            required: true,
        },
        loading: {
            default: false,
            required: false,
        },
    },
}
</script>

<style lang="scss">
#fact-check-app{
    .latest_claims{
        #polling-data-rcp{
            table{
                tbody{
                    tr{
                        td.summary{
                            padding-left: 10px !important;
                        }
                    }
                }
            }
        }
    }
}
</style>